import React, { useState } from 'react';
import { Col, Row } from '../../lib/utils';
import { colors } from '../../lib/colors';
import { Body2Regular, Subtitle1Bold } from '../../lib/font';
import ColorSquareButton from '../Button/ColorSquareButton';
import WhiteSquareButton from '../Button/WhiteSquareButton';
import { useConvertMemberType } from '@/features/publicMember/hooks';
import { ICenterMember, MemberType } from '@/features/publicMember/types';

const TYPE_OPTIONS: { code: 'temp' | 'original'; label: string }[] = [
    { code: 'temp', label: '수강 회원 (앱 미사용)' },
    { code: 'original', label: '수강 회원 (앱 사용)' },
];

interface Props {
    isVisible: boolean;
    onClose: () => void;
    member: ICenterMember | null;
    centerId: string;
    createAlert: any;
}

const MemberTypeConvertModal = ({ isVisible, onClose, member, centerId, createAlert }: Props) => {
    const [targetType, setTargetType] = useState<MemberType | ''>('');
    const convertMutation = useConvertMemberType();

    const availableTypes = TYPE_OPTIONS.filter((opt) => opt.code !== member?.memberType);

    const handleConvert = async () => {
        if (!member || !targetType) return;
        try {
            await convertMutation.mutateAsync({
                centerId,
                memberId: member.memberId,
                body: { targetType, reason: 'admin_reclassify' },
            });
            onClose();
            setTargetType('');
            createAlert('전환 완료', `회원 타입이 변경되었습니다.`, false);
        } catch {
            createAlert('전환 실패', '회원 타입 변경에 실패했습니다.', true);
        }
    };

    if (!isVisible || !member) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center"
            style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
            onClick={onClose}
        >
            <Col
                className="bg-white rounded-[16px] p-[32px] w-[400px]"
                onClick={(e) => e.stopPropagation()}
            >
                <Subtitle1Bold>회원 타입 전환</Subtitle1Bold>

                <Col className="mt-[20px] gap-[12px]">
                    <Body2Regular color={colors.LAVEL_2}>
                        {member.name} ({TYPE_OPTIONS.find((t) => t.code === member.memberType)?.label})
                    </Body2Regular>

                    <Body2Regular color={colors.LAVEL_2} className="mt-[8px]">전환할 타입</Body2Regular>
                    <Col className="gap-[8px]">
                        {availableTypes.map((opt) => (
                            <button
                                key={opt.code}
                                className={`py-[10px] rounded-[8px] border text-[14px] transition-colors ${
                                    targetType === opt.code
                                        ? 'bg-blue-500 text-white border-blue-500'
                                        : 'bg-white text-gray-600 border-[#E1E4E6] hover:border-blue-300'
                                }`}
                                onClick={() => setTargetType(opt.code)}
                            >
                                {opt.label}
                            </button>
                        ))}
                    </Col>
                </Col>

                <Row className="mt-[24px] gap-[12px] justify-end">
                    <WhiteSquareButton text="취소" size="small" callBack={onClose} />
                    <ColorSquareButton
                        text="전환"
                        size="small"
                        isDisabled={!targetType || convertMutation.isLoading}
                        callBack={handleConvert}
                    />
                </Row>
            </Col>
        </div>
    );
};

export default MemberTypeConvertModal;
